import React from 'react';
import { Tooltip, Tag, Space, Typography } from 'antd';
import { MailOutlined, UserOutlined, TeamOutlined } from '@ant-design/icons';
import { ProjectTeamAssignment } from '../../types';
import { useLookups } from '../../context/LookupsContext';

const { Text } = Typography;

interface TeamTooltipProps {
  teamCode: string;
  teamAssignments?: ProjectTeamAssignment[];
  showTag?: boolean;
  tagColor?: string;
}

const TeamTooltip: React.FC<TeamTooltipProps> = ({
  teamCode,
  teamAssignments = [],
  showTag = true,
  tagColor = 'default',
}) => {
  const { getTeamName } = useLookups();

  // Find all assignments for this team
  const assignments = teamAssignments.filter((a) => a.teamCode === teamCode);
  const teamName = getTeamName(teamCode);

  const tooltipContent = (
    <div>
      <div style={{ marginBottom: 4 }}>
        <Space>
          <TeamOutlined />
          <Text strong style={{ color: '#fff' }}>{teamName}</Text>
        </Space>
      </div>
      {assignments.length > 0 ? (
        <div>
          {assignments.map((assignment, index) => (
            <div key={assignment.email} style={{ marginBottom: index < assignments.length - 1 ? 8 : 0 }}>
              {assignment.name && (
                <div>
                  <Space>
                    <UserOutlined />
                    <span>{assignment.name}</span>
                  </Space>
                </div>
              )}
              <div>
                <Space>
                  <MailOutlined />
                  <a href={`mailto:${assignment.email}`} style={{ color: '#69c0ff' }}>
                    {assignment.email}
                  </a>
                </Space>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <Text type="secondary" style={{ color: 'rgba(255,255,255,0.65)' }}>
          No contact assigned
        </Text>
      )}
    </div>
  );

  if (showTag) {
    return (
      <Tooltip title={tooltipContent}>
        <Tag color={tagColor} style={{ cursor: 'pointer' }}>
          {teamCode}
        </Tag>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={tooltipContent}>
      <span style={{ cursor: 'pointer' }}>{teamCode}</span>
    </Tooltip>
  );
};

export default TeamTooltip;
